import React from 'react';
import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import {TextField} from "formik-material-ui";
import {Button, Modal} from "@vadiun/react-components";
import { InputLabel } from '@material-ui/core';
import { ViajeCanalesDeIngreso } from 'app/viaje/models';

interface Props {
    isOpen: boolean,
    onClose: () => void,
    cancel: (reservationId: number, cancelObservation: string, cancellationReasonClient: string) => Promise<void>,
    reservation: any
}

function CancelViajeTrasladoModal({isOpen,onClose,cancel,reservation}: Props) {
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            body={
                <Formik
                    initialValues={{cancelObservation: "", cancellation_reason_client: ""}}
                    onSubmit={async (values, formikHelpers) => {
                        cancel(reservation.id!, values.cancelObservation, values.cancellation_reason_client);
                        formikHelpers.resetForm()
                    }}
                    validationSchema={Yup.object().shape({
                        cancelObservation: Yup.string().required('Ingrese un motivo'),
                        cancellation_reason_client: Yup.string()
                            .test(
                              'is-required-for-app',
                              'Ingrese un mensaje',
                              function(value) {
                                if (reservation?.entryChannel === ViajeCanalesDeIngreso.APP) {
                                  return !!value;
                                }
                                return true; 
                              }
                            )
                    })}
                >
                    {({touched, errors, submitForm}) => (
                        <Form>
                            <div className='flex flex-col gap-10'>
                                <div className='flex flex-col gap-2'>
                                    <InputLabel>Motivo de la cancelación</InputLabel>
                                    <Field
                                        name="cancelObservation"
                                        component={TextField}
                                        fullWidth
                                        placeholder="Ingrese el motivo"
                                    />
                                </div>
                           { reservation?.entryChannel ===  ViajeCanalesDeIngreso.APP &&    <div className='flex flex-col gap-2'>
                                    <InputLabel>Mensaje para el usuario de la app</InputLabel>
                                    <Field
                                        name="cancellation_reason_client"
                                        component={TextField}
                                        fullWidth
                                        placeholder="Ingrese el mensaje"
                                    />
                                </div>}
                            </div>
                            <div className="flex justify-end mt-8">
                                <Button type="submit" variant="contained">
                                    Guardar
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            }
        />
    );
}

export default CancelViajeTrasladoModal;
